// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-blank-page-js": () => import("./../src/BlankPage.js" /* webpackChunkName: "component---src-blank-page-js" */)
}

